<div class="dialog">
  <div class="close">
    <button class="close-btn" (click)="ackForm.reset(); dialog.closeAll()" mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
  </div>
  <div class="dialog-container">
    <div class="title">{{'Stories.donations.claimYourAckNow' | translatePipe | async}}</div>
    <div class="desc">{{'Stories.bankTransfer.paymentOption' | translatePipe | async}}</div>
    <form [formGroup]="ackForm" class="form" (ngSubmit)="submit()">
      <div class="row">
        <div *ngIf="!isMobile" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 payments-opts">
          <p>{{'Stories.bankTransfer.paymentModeTitle' | translatePipe | async}}</p>
          <mat-radio-group formControlName="mode" (change)="changePlaceholder(mode.value)">
            <mat-radio-button color="primary" [ngClass]="{'active': mode.value=='paytm'}" value="paytm">{{'Stories.upiPayment.paytm' | translatePipe | async}}</mat-radio-button>
            <mat-radio-button color="primary" [ngClass]="{'active': mode.value=='upi'}" value="upi">{{'Stories.upiPayment.upi' | translatePipe | async}}</mat-radio-button>
            <mat-radio-button color="primary" [ngClass]="{'active': mode.value=='bank'}" value="bank">{{'Stories.bankTransfer.bankTransfer' | translatePipe | async}}</mat-radio-button>
          </mat-radio-group>
        </div>
        <div *ngIf="isMobile" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 payments-select">
          <mat-form-field class="select-field">
            <mat-select placeholder="Select Payment Mode" formControlName="mode" (selectionChange)="changePlaceholder(mode.value)">
              <mat-option value="paytm">{{'Stories.upiPayment.paytm' | translatePipe | async}}</mat-option>
              <mat-option value="upi">{{'Stories.upiPayment.upi' | translatePipe | async}}</mat-option>
              <mat-option value="bank">{{'Stories.bankTransfer.bankTransfer' | translatePipe | async}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <app-input *ngIf="bankTxnId" inputType="text"
                    [control]="bankTxnId"
                    [group]="ackForm"
                    [placeHolder]="info.bankTxnId.placeholder | translatePipe | async"
                    [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                    [errorMessage]="info.bankTxnId.error">
          </app-input>
          <app-input inputType="text"
                    [control]="donorName"
                    [group]="ackForm"
                    [placeHolder]="'Stories.donations.name.placeholder' | translatePipe | async"
                    [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                    [errorMessage]="'Stories.donations.name.error' | translatePipe | async">
          </app-input>
          <app-phone-number-input-v2
            inputId="mobileInput"
            theme="material"
            [group]="ackForm"
            [control]="donorNumber"
            [hideSuffix]="true"
            (onCountryChange)="setCountry($event)"
          />

        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
          <app-input inputType="text"
                    [control]="amount"
                    [group]="ackForm"
                    [placeHolder]="'Stories.bankTransfer.amtDonated' | translatePipe | async"
                    [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                    [errorMessage]="info.amount.error">
          </app-input>
          <mat-checkbox class="anonymous-check" formControlName="isAnonymous" color="primary">
            {{'Stories.bankTransfer.anonymousModeTitle' | translatePipe | async}}
          </mat-checkbox>
          <app-input inputType="email"
                    [control]="donorEmail"
                    [group]="ackForm"
                    [placeHolder]="'Stories.donations.email.placeholder' | translatePipe | async"
                    [fieldRequired]="'Stories.bankTransfer.requiredField' | translatePipe | async"
                    [errorMessage]="'Stories.donations.email.error' | translatePipe | async">
          </app-input>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <app-button [isLoading]="isLoading" class="app-button" type="submit" btnClass="primary-btn" [label]="'Stories.bankTransfer.submit' | translatePipe | async" ></app-button>
        </div>
      </div>
    </form>
  </div>
</div>
